module.exports = __webpack_public_path__ + "img/title-logo.47721183.png";